/* -------------------------------------------------------------------------- */
/*                                Option list styles                */
/* -------------------------------------------------------------------------- */

@import './bq-option-list.variables';

:host {
  @apply block;
}
